module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0137.jpg?v=dee0a55a";